import { Outlet } from "react-router-dom";
import MiniSidebar from "./mini-sidebar/MiniSidebar";

export default function MasterLayout() {
  /** */

  return (
    <div className="flex flex-col md:flex-row h-dvh overflow-hidden">
      <MiniSidebar />
      <div className="flex-grow overflow-x-hidden">
        <Outlet />
      </div>
    </div>
  );
}
